import { Requests } from '@config/request';
import { BRAND_SAAS_DOMAIN_URL } from '@constants/system';
import { HostTelemetryPayload } from '@config/telemetry';

export const HOST_TELEMETRY_API_PATH = `${BRAND_SAAS_DOMAIN_URL}/api/creator/telemetry/events`;

const DEDUPE_WINDOW_MS = 1000;
let lastTrackedKey = '';
let lastTrackedTime = 0;

export const sendHostTelemetryEvent = (payload: HostTelemetryPayload): void => {
  if (typeof window === 'undefined') return;

  // Deduplicate rapid PAGE_VIEW / TAB_VIEW events
  if (payload.event_type === 'PAGE_VIEW' || payload.event_type === 'TAB_VIEW') {
    const currentKey = `${payload.event_type}_${payload.page_route || ''}_${payload.tab_name || ''}`;
    const now = Date.now();
    if (currentKey === lastTrackedKey && now - lastTrackedTime < DEDUPE_WINDOW_MS) {
      return;
    }
    lastTrackedKey = currentKey;
    lastTrackedTime = now;
  }

  Requests.post(HOST_TELEMETRY_API_PATH, payload).catch(() => {
    // Fire and forget: telemetry failure must never impact the user experience.
  });
};
